import list from 'src/modules/indicator/list/indicatorListReducers';
import form from 'src/modules/indicator/form/indicatorFormReducers';
import view from 'src/modules/indicator/view/indicatorViewReducers';
import destroy from 'src/modules/indicator/destroy/indicatorDestroyReducers';
import importerReducer from 'src/modules/indicator/importer/indicatorImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
